import Vue from 'vue'
import CustomTable from '@/components/custom/table/Component.vue'
import WVInput from '@/components/WVInput.vue'

Vue.component('WVInput', WVInput)
Vue.component('CustomTable', CustomTable)
